import { render, staticRenderFns } from "./SpaceHeader.vue?vue&type=template&id=1aa77544&scoped=true"
import script from "./SpaceHeader.vue?vue&type=script&lang=ts"
export * from "./SpaceHeader.vue?vue&type=script&lang=ts"
import style0 from "./SpaceHeader.vue?vue&type=style&index=0&id=1aa77544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa77544",
  null
  
)

export default component.exports